
import { easeInQuad, easeOutQuad, easeInOutQuad, easeInCubic, easeOutCubic, easeInOutCubic, easeInQuart, easeOutQuart, 
    easeInOutQuart, easeInQuint, easeOutQuint, easeInOutQuint, easeInSine, easeOutSine, easeInOutSine, easeInExpo, 
    easeOutExpo, easeInOutExpo, easeInCirc, easeOutCirc, easeInOutCirc, easeInElastic, easeOutElastic, easeInOutElastic, 
    easeInBack, easeOutBack, easeInOutBack, easeInBounce, easeOutBounce, easeInOutBounce } from 'js-easing-functions';
import GSObject from '../GSObject';

const EasingFunctions = {
    easeInQuad,
    easeOutQuad,
    easeInOutQuad,
    easeInCubic,
    easeOutCubic,
    easeInOutCubic,
    easeInQuart,
    easeOutQuart,
    easeInOutQuart,
    easeInQuint,
    easeOutQuint,
    easeInOutQuint,
    easeInSine,
    easeOutSine,
    easeInOutSine,
    easeInExpo,
    easeOutExpo,
    easeInOutExpo,
    easeInCirc,
    easeOutCirc,
    easeInOutCirc,
    easeInElastic,
    easeOutElastic,
    easeInOutElastic,
    easeInBack,
    easeOutBack,
    easeInOutBack,
    easeInBounce,
    easeOutBounce,
    easeInOutBounce
};

const AnimationState = {
    Paused: 0,
    Playing: 1
}

const AnimationDirection = {
    Forward: 0,
    Backward: 1
}

const AnimationBehaviour = {
    Once: 0,
    Reset: 1,
    Pong: 2
}

export { EasingFunctions };

export class AnimatedNumber extends GSObject {
    constructor(gsoParent, easeFunction, start, end, duration) {
        super(gsoParent);
        this.easeFunction = easeFunction;
        this.start = start;
        this.value = this._copyValue(start);
        this.end = end;
        this.duration = duration;
        this.time = 0;
        this.state = AnimationState.Paused;
        this.behaviour = AnimationBehaviour.Reset;
        this.backwardEaseFunction = easeFunction;
        this.direction = AnimationDirection.Forward;
    }

    pong(backwardEaseFunction) {
        if (backwardEaseFunction)
            this.backwardEaseFunction = backwardEaseFunction;
        this.behaviour = AnimationBehaviour.Pong;
    }

    _copyValue(valA) {
        return valA;
    }

    _updateValueFromFunction() {
        this.value = this._useEaseFunction(this.time, this.start, this.end, this.duration);
    }

    _useEaseFunction(time, start, end, duration) {
        if (this.direction === AnimationDirection.Forward)
            return this.easeFunction(time, start, end - start, duration);
        return this.backwardEaseFunction(time, start, end - start, duration);
    }

    play() {
        this.state = AnimationState.Playing;
    }

    pause() {
        this.state = AnimationState.Paused;
    }

    stop() {
        this.time = 0;
        this._updateValueFromFunction();
        this.pause();
    }

    onUpdate(deltaTime) {
        if (this.state === AnimationState.Playing) {
            if (this.direction === AnimationDirection.Forward)
                this.time += deltaTime / 1000;
            else
                this.time -= deltaTime / 1000;

            if (this.time > this.duration) {
                this.time = this.duration;
                if (this.behaviour === AnimationBehaviour.Reset)
                    this.stop();
                else if (this.behaviour === AnimationBehaviour.Once)
                    this.pause();
                else if (this.behaviour === AnimationBehaviour.Pong) {
                    this.direction = AnimationDirection.Backward;
                }
            }
            else if (this.time < 0) {
                this.time = 0;
                if (this.behaviour === AnimationBehaviour.Pong) {
                    this.direction = AnimationDirection.Forward;
                    this.stop();
                }
            }

            this._updateValueFromFunction();
        }
    }
}

export class AnimatedVector extends AnimatedNumber {
    _copyValue(valA) {
        return valA.copy();
    }

    _updateValueFromFunction() {
        this.value.x = this._useEaseFunction(this.time, this.start.x, this.end.x, this.duration);
        this.value.y = this._useEaseFunction(this.time, this.start.y, this.end.y, this.duration);
    }
}